import ServiceDetail from "@/components/ServiceDetail";
import { SERVICES_DATA } from "@/data/services";
import { GALLERY_ITEMS } from "@/data/gallery";

export default function Fencing() {
    const projects = GALLERY_ITEMS.filter((g) => g.category === "fencing");
    return <ServiceDetail data={SERVICES_DATA.fencing} projects={projects} />;
}
